module.exports = __webpack_public_path__ + "static/media/pz.5bcc84c9.hdr";